export const Enum_Currency = Object.freeze({
  CNY: "人民币",
  USD: "美元",
  USDTERC: "USDTERC",
  USDT: "USDT",
});

export const getDisplayCurrencyText = (currency) => {
  const text = Enum_Currency[currency];
  return text || currency;
};

export const getDevice = () => {
  // const isIOS = !!navigator.platform.match(/ipad|iphone|ipod|mac/gi);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isMobile = !!navigator.userAgent.match(/mobile|iphone|ipad|android/gi);
  return { isIOS, isMobile };
};

export const errorMap = Object.freeze({
  appInfo: "000",
  getFaceChannel: "001",
  getFaceStatus: "002",
  goDeposit: "003",
  goWithdrawal: "004",
  getAuthInfo: "005",
  getCacheCustomerByToken: "006",
});

export const checkEnableMT5 = (queryParam) => {
  const includedFlavors = process.env.VUE_APP_MT5_INCLUDED_FLAVORS.split(",").map(flavor => flavor.toUpperCase());
  if (
    getDevice().isIOS &&
    queryParam.flavor &&
    !includedFlavors.includes(queryParam.flavor.toUpperCase())
  ) {
    localStorage.setItem("enableMT5", "false");
  }
};

export const isMT5Enabled = () => {
  return JSON.parse(localStorage.getItem("enableMT5"));
};

export const removeQueryParam = (url, paramKey) => {
  const urlObj = new URL(url)
  const searchParams = urlObj.searchParams
  searchParams.delete(paramKey)
  urlObj.search = searchParams.toString()
  return urlObj.toString()
}
